/* global gtag */
import React, { createContext, useState, useEffect } from 'react'
import Cookies from 'js-cookie'

export const CookieConsentContext = createContext()

const CookieConsentProvider = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState({
    ad_storage: 'denied',
    analytics_storage: 'denied',
    personalization_storage: 'denied', // não usado
    functionality_storage: 'denied', // não usado ainda
    security_storage: 'denied', // não usado
  })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  useEffect(() => {
    try {
      const consentModeStr = Cookies.get('consentMode')
      const consentMode = consentModeStr ? JSON.parse(consentModeStr) : null
      if (!consentMode) {
        setIsDrawerOpen(true)
      } else {
        setIsDrawerOpen(false)
      }
    } catch (error) {
      // console.error('Erro ao acessar Cookies:', error)
    }
  }, [])

  const acceptCookies = () => {
    const consentData = {
      ad_storage: 'granted',
      analytics_storage: 'granted',
    }
    setCookieConsent(consentData)
    gtag('consent', 'update', consentData)
    Cookies.set('consentMode', JSON.stringify(consentData))
    setIsDrawerOpen(false)
    setIsModalOpen(false)
  }

  const declineCookies = () => {
    const consentData = {
      ad_storage: 'denied',
      analytics_storage: 'denied',
    }
    setCookieConsent(consentData)
    gtag('consent', 'update', consentData)
    Cookies.set('consentMode', JSON.stringify(consentData))
    setIsModalOpen(false)
  }

  const partialConsent = (analytics, advertising) => {
    const consentData = {
      ad_storage: advertising ? 'granted' : 'denied',
      analytics_storage: analytics ? 'granted' : 'denied',
    }
    setCookieConsent(consentData)
    gtag('consent', 'update', consentData)
    Cookies.set('consentMode', JSON.stringify(consentData))
    toggleDrawer()
    toggleModal()
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen)
  }

  const value = {
    cookieConsent,
    isModalOpen,
    isDrawerOpen,
    acceptCookies,
    declineCookies,
    toggleModal,
    toggleDrawer,
    partialConsent,
  }

  return <CookieConsentContext.Provider value={value}>{children}</CookieConsentContext.Provider>
}

export default CookieConsentProvider
